var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardSvg3Black(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 22,
    height: 22,
    transform: "translate(0.323)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_5",
    "data-name": "Mask Group 5",
    transform: "translate(-0.323)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(0.381 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M6.286,7.857h6.286V9.429H6.286Z",
    transform: "translate(-1.571 -1.571)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M6.286,4.714h9.429V6.286H6.286Z",
    transform: "translate(-1.571 -1.571)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M6.286,1.571h9.429V3.143H6.286Z",
    transform: "translate(-1.571 -1.571)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M3.7,22l4.424-7.854,5.841,5.1a1.571,1.571,0,0,0,2.423-.42l5.476-8.174-1.305-.875-5.5,8.209-.055.081-5.842-5.1a1.574,1.574,0,0,0-2.42.416l-3.6,6.4V1.571H1.571V22a1.573,1.573,0,0,0,1.571,1.571H23.571V22Z",
    transform: "translate(-1.571 -1.571)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardSvg3Black);
export default __webpack_public_path__ + "static/media/card-svg-3-black.32a183167c8e37aa608469d0a5912972.svg";
export { ForwardRef as ReactComponent };